import API from "./api";

/** Mark leave module setup complete for dashboard setup progress (step 7). */
export async function markLeaveSetupConfigured() {
  const savedAt = new Date().toISOString();
  try {
    const res = await API.get("/organisation/me/hr-settings");
    const hr = res?.data?.hr_settings || {};
    const payroll = { ...(hr.payroll || {}) };
    if (payroll.leave_completed === true && payroll.leave_saved_at) {
      return payroll;
    }
    await API.patch("/organisation/me/hr-settings", {
      payroll: {
        ...payroll,
        leave_completed: true,
        leave_saved_at: savedAt,
      },
    });
    return { ...payroll, leave_completed: true, leave_saved_at: savedAt };
  } catch {
    return null;
  }
}
